<div
  class="rounded-full text-xs flex items-center px-2 py-1 text-white font-bold gap-1"
  [class.bg-green-600]="status === 'success'"
  [class.bg-red-700]="status === 'error'"
  [class.bg-sunnyOrange-400]="status === 'warning'"
  [class.bg-gray-700]="!status"
>
  @switch (status) {
    @case ("success") {
      <mat-icon inline="true">check</mat-icon>
    }
    @case ("error") {
      <mat-icon inline="true">error</mat-icon>
    }
    @case ("warning") {
      <mat-icon inline="true">warning</mat-icon>
    }
    @default {
      <mat-icon inline="true">info</mat-icon>
    }
  }
  <ng-content></ng-content>
</div>
